import constants from "../../core/constants";

class Formatter {
  constructor() {
    this.fromPrice = (value) => value * constants.currencyBy;
    this.fromModel = (model) =>
      model._id ? model._id : model.name ? model.name._id : null;
    this.fromPhone = (value) => (value ? value.toString() : null);
  }
}

export default Formatter;



// WEBPACK FOOTER //
// ./src/services/formatter/formatter.service.js